package api


sealed class CampaignType(var type: Int, val label: String) {

    /** NONE: 0*/
    data object NONE : CampaignType(0, "none")

    /** SLOT: 2*/
    data object SLOT : CampaignType(2, "slot")

    /** IMPRESSION: 4*/
    data object IMPRESSION : CampaignType(4, "impression")


    infix fun match(type: Int): Boolean = this.type and type > 0


    companion object {
        val all by lazy {
            arrayOf(NONE, SLOT, IMPRESSION)
        }

        operator fun get(type: Int): CampaignType {
            return all.firstOrNull { it.match(type) } ?: NONE
        }
    }
}
